'use client';

import { usePathname } from 'next/navigation';

export function PreviewBanner() {
  const pathname = usePathname();

  return (
    <div className='z-30 bg-magenta p-2 text-center text-asphalt-10'>
      This is page is a preview.&nbsp;
      <a className='underline' href={`/api/disable-draft?redirectTo=${pathname}`}>
        Click here
      </a>
      &nbsp;to exit preview.
    </div>
  );
}
